interface Params {
  readonly missionTitle: string;
  readonly templateTitle?: string | null;
}

const TITLES_SEPARATOR = ' - ';

export const buildMissionDocumentTitle = ({
  missionTitle,
  templateTitle,
}: Readonly<Params>): string =>
  [missionTitle, templateTitle]
    .filter((title): title is string => !!title)
    .join(TITLES_SEPARATOR);
